import AbTestHttpService from 'abTests/AbTestHttpService';

// START feature/PPIWEBM-1594
const VARIANT_OVERRIDE = 'set_test_variant';
// END feature/PPIWEBM-1594

export default {
    state: {
        // object keys reflect the experiment key from Optimizely
        // object key value reflects the user's variant
        variant: {},
        isAA: false,
    },

    mutations: {
        setVariant(state, variant) {
            state.variant = variant;
        },

        appendOrOverwriteVariants: function (state, newVariants) {
            const variantsToAppend = {};

            for (let test in newVariants) {
                let variantValue = newVariants[test];

                if (test in state.variant) {
                    state.variant[test] = variantValue;
                } else {
                    variantsToAppend[test] = variantValue;
                }
            }

            let mergedVariants = {
                ...state.variant,
                ...variantsToAppend,
            };

            state.variant = mergedVariants;
        },

        setIsAA(state) {
            state.isAA = true;
        },
    },

    actions: {
        setVariant({ commit }, variant) {
            commit('setVariant', variant);
        },

        loadVariantsXhr({ state, commit }, testNamesArray) {
            let filteredNamesArray = [];
            // START feature/PPIWEBM-1594
            const searchParams = new URLSearchParams(window.location.search);
            const testVariantOverride = searchParams.get(VARIANT_OVERRIDE);
            const [expNameOverride, variantOverride] = testVariantOverride
                ? testVariantOverride.split('--')
                : ['', ''];
            // END feature/PPIWEBM-1594

            testNamesArray.forEach((testName) => {
                //check if a variant is loaded for the test already
                if (
                    !state.variant[testName] ||
                    //START AB Test PLGRWEB-936 - Add genres to show picker page
                    testName === 'web_add_genre_tabs_to_cold_start_picker'
                    //END AB Test PLGRWEB-936 - Add genres to show picker page
                ) {
                    filteredNamesArray.push(testName);
                }
            });

            // if all the test names are already set in state then we can exit out of this method
            if (filteredNamesArray.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({});
                });
            }

            return new Promise((resolve, reject) => {
                const abtestService = new AbTestHttpService({
                    isAA: state.isAA,
                });
                abtestService.setState(state);
                abtestService
                    .getVariantMultipleTests(filteredNamesArray)
                    .then((res) => {
                        if (res.success) {
                            if (res.variants) {
                                // START feature/PPIWEBM-1594
                                if (
                                    expNameOverride &&
                                    variantOverride &&
                                    expNameOverride in res.variants
                                ) {
                                    console.log(
                                        `Overriding variant ${expNameOverride} with value ${variantOverride} (Original value was ${res.variants[expNameOverride]})`,
                                    );
                                    res.variants[expNameOverride] = variantOverride;
                                }
                                // END feature/PPIWEBM-1594

                                commit('appendOrOverwriteVariants', res.variants);

                                let bodyClasses = '';

                                testNamesArray.forEach((testName) => {
                                    bodyClasses += ` test-${testName}-${res.variants[testName]}`;
                                });

                                document.body.className += bodyClasses;
                            }
                            resolve(res);
                        }
                        reject(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },

    getters: {
        // returns the entire variant object with all the tests
        getVariant: (state) => {
            return state.variant;
        },

        /**
         * Will return true if the user variant matches the expected variant value by variant key
         * Refer to CBS.AbTestsConfig.modules
         * @param state
         * @param getters
         * @returns {function(*, *): function(*, *): function(*, *): boolean}
         */
        experimentIs: (state, getters) => (moduleKey, variantKey) => {
            return getters._experimentIsVariantByVariantKey(moduleKey, variantKey);
        },

        /**
         * Will return true if the user variant matches the expected variant value by variant key
         * Refer to CBS.AbTestsConfig.modules
         * @param state
         * @param getters
         * @returns {function(*, *): function(*, *): boolean}
         */
        _experimentIsVariantByVariantKey: (state, getters) => (moduleKey, variantKey) => {
            let optimizelyKey = CBS.AbTestsConfigs?.modules[moduleKey]?.experimentKey;
            let variantValue = CBS.AbTestsConfigs?.modules[moduleKey]?.variantKeys[variantKey];
            let userVariant = state.variant[optimizelyKey];
            return typeof optimizelyKey !== 'undefined' && userVariant === variantValue;
        },

        getTrackingData: (state) => () => {
            let trackingOutput = '';
            let i = 0;

            for (let testName in state.variant) {
                if (i !== 0) {
                    trackingOutput += '|';
                }
                trackingOutput += testName + ':' + state.variant[testName];
                i++;
            }

            return trackingOutput;
        },

        abTestVariantIsActive: (state) => (testName, variantValue) => {
            return state.variant[testName] === variantValue;
        },
    },
};
